import { Box } from "@material-ui/core"
import { Modal } from "react-bootstrap"
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const DilutionModal = (props)=>{
    const{open,handleClose,dilutiondata,handleDilutionChange,dataValue,handleDelution}=props
    return(
        <>
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <div className="col-12">
                <input type="button" className="btn btn-defult" value="X" onClick={handleClose} style={{float:"right"}}/>
                    <div className="col-12">
                        <h5>Dilution</h5>
                        <div className="form-group mb-1 col-12">
                            <label>Date of divestment</label>
                            <input type="date" className="form-control" value={dilutiondata.date_of_divest} onChange={(e)=>handleDilutionChange(e,"date_of_divest")}/>
                        </div>
                        <div className="form-group mb-1 col-12">
                            <label>No. of shares divested</label>
                            <input type="text" className="form-control" value={dilutiondata.no_of_share} onChange={(e)=>handleDilutionChange(e,"no_of_share")}/>
                        </div>
                        <div className="form-group mb-1 col-12">
                            <label>Sale value</label>
                            <input type="text" className="form-control" value={dilutiondata.sale} onChange={(e)=>handleDilutionChange(e,"sale")}/>
                        </div>
                        <div className="form-group mb-1 col-12">
                            <label>Cost of Investment
                            </label>
                            <input type="text" className="form-control" value={dataValue} readOnly/>
                        </div>
                        <div className="form-group mb-1 col-12">
                            <input type="button" className="btn btn-primary1" value="Submit" onClick={()=>handleDelution()}/>
                        </div>
                        
                    </div>
                </div>
            </Box>
        </Modal>

        </>
    )
}
export default DilutionModal